export const isTrue = (value) => {
  if (value === null || value === undefined) return false;
  // Convertimos a string, a minúsculas y chequeamos la lista blanca
  return ["true", "1"].includes(String(value).toLowerCase());
};

// Obtener el lenguaje/locale del navegador en formato "es_ES"
export const getBrowserLocale = () => {
  const locale = navigator.language || navigator.userLanguage || "en-US";
  const [lang, region] = locale.split("-");
  return `${lang}_${region?.toUpperCase() || "US"}`;
};

// Obtener los separadores decimal y de miles según el locale
export const getLocaleNumberSeparators = (locale) => {

  // Convertir "-" a "_" si es necesario
  locale = locale.replace("_", "-");

  const number = 1234.56; // Número de prueba
  const formatted = new Intl.NumberFormat(locale).format(number);

  const decimalSeparator = formatted.includes(",") ? "," : ".";
  const thousandSeparator = formatted.includes(".") ? "." : ",";

  return { decimalSeparator, thousandSeparator };
}

// Función para formatear número según Locale
export const formatNumberByLocale = (value, locale, options = {}) => {
  if (value === null || value === undefined || isNaN(value)) return "";
  // Convertir "-" a "_" si es necesario
  locale = locale.replace("_", "-");
  return new Intl.NumberFormat(locale, options).format(value);
};

// Función para formatear fecha según Locale
export const formatDateByLocale = (dateString, inputMask, locale, options = {}) => {
  if (!dateString || !inputMask) return "";

  // Detectar el separador en el dateString
  const separator = dateString.includes("-")
    ? "-"
    : dateString.includes("/")
    ? "/"
    : dateString.includes("_")
    ? "_"
    : null;

  if (!separator) return ""; // Si no hay separador válido, retornar vacío

  // Dividir el dateString y el inputMask en partes
  const dateParts = dateString.split(separator);
  const maskParts = inputMask.split(separator);

  if (dateParts.length !== maskParts.length) return ""; // Validar que coincidan las partes

  // Crear un objeto con las partes de la fecha
  const dateObject = {};
  maskParts.forEach((part, index) => {
    dateObject[part.toLowerCase()] = dateParts[index];
  });

  // Formatear la fecha según el locale
  const day = dateObject["dd"] || dateObject["d"] || "";
  const month = dateObject["mm"] || dateObject["m"] || "";
  const year = dateObject["yyyy"] || dateObject["yy"] || "";

  // Opciones de formato por defecto
  const defaultOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  };

  const formatOptions = { ...defaultOptions, ...options };

  // Construir la fecha formateada
  locale = locale.replace("_", "-");
  
  const formattedDate = new Intl.DateTimeFormat(locale, formatOptions).format(
    new Date(`${year}-${month}-${day}`)
  );

  return formattedDate;
};
